import { createReducer } from '@reduxjs/toolkit'
import { clearCurrentFilters, setCurrentFilters } from '../actions'

const currentFiltersInitialState = {}

export const currentFilters = createReducer(currentFiltersInitialState, {
  [clearCurrentFilters.type]: (state, action) => currentFiltersInitialState,
  [setCurrentFilters.type]: (state, action) => action.payload,
})
